module.exports = __webpack_public_path__ + "static/img/chongzhiquan.0b07fcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chongzhiquan.jpg
// module id = Coq6
// module chunks = 128